export const DAYS = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];

export const ACTIVITY_STATUS_COLORS = {
  Scheduled: "bg-blue-500/15 text-blue-400",
  Completed: "bg-green-500/15 text-green-400",
  Missed: "bg-amber-500/15 text-amber-400",
  Cancelled: "bg-zinc-700 text-zinc-400",
};

export const CHECKIN_STATUS_COLORS = {
  pending: "bg-amber-500/15 text-amber-400",
  verified: "bg-green-500/15 text-green-400",
  rejected: "bg-[#E53E3E]/15 text-[#E53E3E]",
};

// Display a stored YYYY-MM-DD calendar date in the viewer's locale (timezone-safe: no tz shift).
export function formatDate(dateStr) {
  if (!dateStr) return "—";
  const [y, m, d] = dateStr.split("-").map(Number);
  if (!y || !m || !d) return dateStr;
  return new Date(y, m - 1, d).toLocaleDateString(undefined, { weekday: "short", month: "short", day: "numeric" });
}

export function todayISO() {
  const n = new Date();
  return `${n.getFullYear()}-${String(n.getMonth() + 1).padStart(2, "0")}-${String(n.getDate()).padStart(2, "0")}`;
}
